import { render, staticRenderFns } from "./choserdan.vue?vue&type=template&id=559e59ba&scoped=true"
import script from "./choserdan.vue?vue&type=script&lang=js"
export * from "./choserdan.vue?vue&type=script&lang=js"
import style0 from "./choserdan.vue?vue&type=style&index=0&id=559e59ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e59ba",
  null
  
)

export default component.exports